"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var productInvoice = /** @class */ (function () {
    function productInvoice(props) {
        this.productInvoiceId = props.productInvoiceId;
        this.billingAgreementId = props.billingAgreementId;
        this.amountIncludingTaxes = props.amountIncludingTaxes;
        this.sendDate = props.sendDate;
        this.reference = props.reference;
        this.dueDate = props.dueDate;
        this.invoiceStatusCode = props.invoiceStatusCode;
        this.creationDate = props.creationDate;
        this.typeCode = props.typeCode;
        this.operationalDate = props.operationalDate;
        this.settlementDate = props.settlementDate;
    }
    return productInvoice;
}());
exports.default = productInvoice;
